

import BaseButton from '@/components/BaseButton.vue';
export default {
  name: 'ImageTextVerticalColumn',
  components: {
    BaseButton,
  },
  props: {
    text: {
      type: String,
    },
    maxCharacters: {
      type: String,
    },
    readMoreLabel: {
      type: String,
      default: 'Read more',
    },
    readLessLabel: {
      type: String,
      default: 'Read less',
    },
  },
  data: function() {
    return {
      show: false,
    };
  },
  methods: {
    toggleReadMore() {
      this.show = !this.show;
    },
    renderText() {
      if (this?.text?.content && typeof this.text.content === 'string') {
        return this.show ? this.text.content : this.text.content.substring(0, 170)+'&mldr;';
      }
      return '';
    },
  },
};
